<template>
    <NavBar />
    <div class="w-full">
        <ol class="flex gap-2 items-center pt-28 font-normal text-[#001c54] text-[15px] max-w-7xl mx-auto">
            <li><a href="/">Home</a></li>
            <li>> Refund Policy</li>
        </ol>

        <div class="max-w-7xl mx-auto w-full text-left">
            <h2 class="mt-5 text-black font-bold text-lg md:text-lg md:text-[20px] text-left ">Refund <span
                    class="text-[#dc3545]"> Policy</span></h2>

            <h4 class="mt-6 text-black font-bold text-left text-lg md:text-[18px]">Scope</h4>

            <p class=" text-normal text-[12px] md:text-[15px] text-black">The refund policy lays out complete
                information and guidance about the fee
                refund process applicable to learners, the process of applying for refunds and
                the conditions under which refunds will be provided.</p>
            <p class=" text-normal text-[12px] md:text-[15px] text-black">This policy is applicable for all learners
                enrolled in the online programs offered
                by the Centre for Distance and Online Education.</p>


            <h4 class="text-black font-bold text-left text-lg md:text-[18px] pb-2">Circumstances for processing a<span
                    class="text-[#dc3545]"> refund</span></h4>
            <p class="text-normal text-[12px] md:text-[15px] text-black"><strong>Admission rejected by the University</strong> - In case
                the admission is rejected by the
                University, a complete refund of Program Fee, Registration Fee and
                Examination Fee will be made.</p>
            <p class=" text-normal text-[12px] md:text-[15px] text-black"><strong>Program Cancelled / Withdrawn by University</strong> –
                In case of cancellation or
                withdrawal of a program by the University, complete refund of Program Fee,
                Registration Fee and Examination Fee will be made.</p>
            <p class="text-normal text-[12px] md:text-[15px] text-black"><strong>Learner Requested for a refund</strong>: In case of
                a request from a learner for
                cancellation of admission and refund of fees, the following table will be
                applicable:</p>

            <div class="hscroll">
                <table cellpadding="10px" cellspacing="10px" style="border-spacing: 8px;" width="100%">
                    <tbody>
                        <tr>
                            <th class="bg-[#dc3545] text-white w-[40%];">Time when refund request made</th>
                            <th class="bg-[#dc3545] text-white w-[40%];">Amount of Refund Applicable</th>
                        </tr>
                        <!-- <tr>
                            <td class="bg-[#f7f9fb]" style="">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">More than 15 days prior to
                                    the notified
                                    last date of admission</p>
                            </td>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Refund of 100% of Program
                                    Fee and Full Examination Fee</p>
                            </td>

                        </tr> -->
                        <tr>
                            <td class="bg-[#f7f9fb]" style="">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">More than 15 days prior to
                                    the notified
                                    last date of admission</p>
                            </td>
                            <td class="bg-[#f7f9fb]" style="">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Refund of 90% of Program
                                    Fee and Full Examination Fee</p>
                            </td>

                        </tr>
                        <tr>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Within 15 days after the
                                    notified last date of admission</p>
                            </td>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Refund of 80% of Program
                                    Fee and Full Examination Fee</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Between 15 days and 30 days
                                    after the notified last date of admission</p>
                            </td>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">Refund of 50% of Program
                                    Fee and Full Examination Fee</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">More than 30 days after the
                                    notified last date of admission</p>
                            </td>
                            <td class="bg-[#f7f9fb]" style=" ">
                                <p class="text-normal text-[12px] md:text-[15px] text-black">No Refund</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="my-2 p-2">
                <h4 class="text-black font-bold text-left text-lg md:text-[18px] ">Procedure for <span
                        class="text-[#dc3545]"> Refund:</span></h4>
                <ul class="text-normal text-[12px] md:text-[16px] text-black mt-3 pl-1 list-disc ml-4">
                    <li>Refund request must be raised online  on the VISA portal by the learner through by filling the refund form and providing complete details and supporting documents.</li>
                    <li>Refund request will be verified within 48 hours of receipt of the
                        application and will be sent for further process.</li>
                    <li>In case fees paid through loan assistance, the loan company will be
                        intimated to stop further EMIs and initiate the refund of EMIs already
                        debited up to the extent of eligible refund amount.</li>
                    <li>Refund will be made within 25 days of the approval of refund.</li>
                    <li>The details of the refund made will be shared with the learner.</li>
                </ul>

            </div>




            <p class="text-normal text-[12px] md:text-[15px] text-black mt-3 pl-1">Refund requests shall be processed
                within 30 working days post the confirmation of academics team.</p>

            <p class="text-normal text-[12px] md:text-[15px] text-black mb-[10%] py-3 pl-1"><strong>NOTE: For any
                    refund-related enquiries, you may contact the Email ID <a
                        href="mailto:learnersupport@vignanonline.com"
                        class="text-[#254483]">learnersupport@vignanonline.com </a> | <a
                        href="/brochure/Refund Policy_VO.pdf" target="_blank"
                        class="text-[#254483]">Click here to Download Refund Policy </a></strong> </p>
        </div>

        <FooterView />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FooterView from './FooterView.vue';
export default {
    name: "RefundPolicy",
    components: { 
        FooterView,
        NavBar 
     }
}
</script>

<style scoped>
table,
th,
td {
    border: 5px solid #fff;
    border-collapse: collapse;
    padding: 10px;

}

.hscroll {
    overflow-x: auto;
}
</style>